import { request } from "../network/request";
const db = "dn0";


/**
 * 获取计划信息列表
 * @param {*} range 数据范围 1-角色数据权限 0-全部
 * @param {*} xmbh 项目编号
 * @returns
 */
export function getPlanList(params) {
    return request({
        url: "system/getPlanList",
        method: "get",
        params: {
            db,
            ...params
        },
    });
}


//获取当前时间一年内的周期列表
export function getAuditList(data) {
    return request({
        url: "pmp/xmReview/MyReviewList",
        method: "post",
        params: {
            ...data,
            db,
        },

    });
}
// 获取报告编写审核页面数据
export function getAuditData(data) {
    return request({
        url: "pmp/xmReview/getZxpsReviewById",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}


// 效果评估	策略制定评审保存
export function saveAuditData(data) {
    return request({
        url: "pmp/xmReview/saveZxpsReview",
        method: "post",
        data: {
            ...data,
            db,
        },

    });
}
//报告编写审核保存
export function saveAuditData2(data) {
    return request({
        url: "pmp/xmReview/saveBgbxReview",
        method: "post",
        data: {
            ...data,
            db,
        },

    });
}
// 获取过往评估主题
export function getHistory(data) {
    return request({
        url: "pmp/xmReview/gwpgList",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}

/**
 * 获取效果评估策略制定申请数据
 * @param {*} data 
 * @returns 
 */
export function getClzdApply(data) {
    return request({
        url: "pmp/xmApply/getClzdApply",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}
/**
 * 保存评估策略制定申请
 * @param {*} data 
 * @returns 
 */
export function saveClzdApply(data) {
    return request({
        url: "pmp/xmApply/saveClzdApply",
        method: "post",
        data: {
            ...data,
            db,
        },

    });
}
/**
 * 提交评估策略制定申请
 * @param {*} data 
 * @returns 
 */
export function submitClzdApply(data) {
    return request({
        url: "pmp/xmApply/submitClzdApply",
        method: "post",
        data: {
            ...data,
            db,
        },

    });
}

/**
 * 获取效果评估报告编写数据
 * @param {*} data 
 * @returns 
 */
export function getZxpsApply(data) {
    return request({
        url: "pmp/xmApply/getZxpsApply",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}

/**
 * 报告编写保存
 * @param {*} data 
 * @returns 
 */
export function saveZxpsApply(data) {
    return request({
        url: "pmp/xmApply/saveZxpsApply",
        method: "post",
        data: {
            ...data,
            db,
        },

    });
}

/**
 * 报告编写提交
 * @param {*} data 
 * @returns 
 */
export function submitZxpsApply(data) {
    return request({
        url: "pmp/xmApply/submitZxpsApply",
        method: "post",
        data: {
            ...data,
            db,
        },

    });
}

/**
 * 过往主题
 * @param {*} data 
 * @returns 
 */
export function getZxpsGw(data) {
    return request({
        url: "pmp/xmApply/getZxpsGw",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}


export function uploadFile(data) {
    return request({
        url: "pmp/xmApply/upload",
        method: "post",
        data: data,
    });
}

export function getLinkTask(data) {
    return request({
        url: "pmp/xmApply/getLinkTask",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}

export function getClzdType(data) {
    return request({
        url: "pmp/xmApply/getClzdType",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}

/**
 * 删除文件
 * @param {*} data data.fileId 文件id data.path 文件路径
 * @returns 
 */
export function delFileInfo(data) {
    return request({
        url: "pmp/xmApply/delFileInfo",
        method: "get",
        params: {
            ...data,
            db,
        },

    });
}

